const poBoxRegex = /P\.?O\.?\s?Box/i;

export function isPoBox(address: string | undefined): boolean {
    return address && address.match(poBoxRegex) !== null;
}
